import { FormBase } from 'core/components';

export default class LabelingStepForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'upc',
					label: 'FULFILLMENTORDER.LABELINGMODE.UPC',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/labeling-mode/LabelingStepForm.js